import { defineMessages } from "react-intl";

const messages = defineMessages({
  password: {
    id: "riskManagement.components.login.password",
    defaultMessage: "Password",
  },
  submit: {
    id: "riskManagement.components.login.submit",
    defaultMessage: "Submit",
  },
  title: {
    id: "riskManagement.components.login.title",
    defaultMessage: "Login",
  },
  username: {
    id: "riskManagement.components.login.username",
    defaultMessage: "Username",
  },
});

export default messages;
